import React from "react";
import { Link } from "react-router-dom";
import clubLogoImg from "../../assets/images/SportMingleLogoMark.png";
import "../../styles/ErrorPage.css";

const ErrorPage = ({
  onRetry = () => window.location.reload(),
  homeTo = "/",
}) => {
  return (
    <div className="sm-error-page" data-testid="error-page">
      <div className="sm-error-page-field" aria-hidden="true">
        <span className="sm-error-page-baseline" />
        <span className="sm-error-page-circle" />
        <span className="sm-error-page-ball" />
      </div>
      <div className="sm-error-page-panel">
        <div className="sm-error-page-brand">
          <img src={clubLogoImg} alt="" className="sm-error-page-mark" />
          <span>SportMingle</span>
        </div>
        <p className="sm-error-page-kicker">Short timeout</p>
        <h1>This play didn&apos;t go through</h1>
        <p className="sm-error-page-copy">
          We hit a snag loading this screen. Try again, or jump back to your dashboard
          and keep moving.
        </p>
        <div className="sm-error-page-actions">
          <button
            type="button"
            className="sm-error-page-retry"
            data-testid="error-page-retry"
            onClick={onRetry}
          >
            Try again
          </button>
          <Link to={homeTo} className="sm-error-page-home" data-testid="error-page-home">
            Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
